// Brand data & constants for Imporparts — Soluções Corporativas e Industriais
export const BRAND = {
  name: "Imporparts",
  fullName: "Imporparts — Soluções Corporativas e Industriais",
  tagline: "Mantemos operações em movimento.",
  subtagline:
    "Somos especialistas em soluções corporativas e industriais, fornecendo peças, equipamentos, nacionalização de componentes e soluções inteligentes para garantir a continuidade operacional da sua empresa.",
  phone: "(11) 2670-4419",
  whatsapp: "(11) 98896-0809",
  whatsappLink:
    "https://wa.me/5511988960809?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20cota%C3%A7%C3%A3o.",
  email: "comercial@imporparts.com.br",
  address: {
    street: "Rua Tânia, 329",
    district: "Jardim Carapicuíba",
    city: "Carapicuíba",
    state: "SP",
    country: "Brasil",
    hours: "Segunda a Domingo — 08:00 às 18:00",
  },
  logoUrl:
    "https://customer-assets-agu9un31.emergentagent.net/job_33a9c3a1-f2a4-42eb-9986-662153705b4b/artifacts/kf7233c4_WhatsApp%20Image%202026-07-01%20at%2009.21.42.jpeg",
  institutionalVideoUrl:
    "https://customer-assets-agu9un31.emergentagent.net/job_supply-reliability/artifacts/asqbmdw0_WhatsApp%20Video%202026-07-28%20at%2022.37.09.mp4",
};

export const DIFFERENTIALS = [
  { title: "Engenharia de Suprimentos", desc: "Análise técnica e estratégica de cada demanda — não fornecemos peças, entregamos soluções." },
  { title: "Nacionalização de Componentes", desc: "Substituímos itens importados por equivalentes nacionais de alta qualidade, reduzindo custo e dependência externa." },
  { title: "Importação Especializada", desc: "Sourcing global com rastreabilidade total, laudos técnicos e desembaraço aduaneiro completo." },
  { title: "Atendimento Consultivo", desc: "Engenheiros e especialistas entendem sua operação antes de propor qualquer solução." },
  { title: "Soluções Sob Medida", desc: "Desenvolvemos alternativas técnicas customizadas para desafios industriais complexos." },
  { title: "Continuidade Operacional", desc: "Nossa missão é impedir que sua produção pare — em qualquer cenário." },
  { title: "Agilidade Logística", desc: "Rotas priorizadas, SLA definido e monitoramento ativo até a entrega técnica." },
  { title: "Alta Disponibilidade", desc: "Gestão de itens críticos com estratégia de estoque, backup e prontidão emergencial." },
  { title: "Atendimento Corporativo", desc: "Homologação de fornecedor, NF-e, condições B2B e processos alinhados ao seu compliance." },
];

export const MARKETS = [
  "Construção", "Agronegócio", "Logística", "Portos",
  "Indústria", "Automação", "Energia", "Mineração",
  "Papel e Celulose", "Siderurgia", "Metalurgia", "Alimentos", "Química",
  "Petróleo e Gás", "Área Offshore", "Refinarias",
  "Estaleiros", "Indústria Naval",
];

export const CATEGORIES = [
  { name: "Rolamentos", icon: "Circle" },
  { name: "Motores", icon: "Zap" },
  { name: "Bombas", icon: "Waves" },
  { name: "Correias", icon: "GitCommitHorizontal" },
  { name: "Acoplamentos", icon: "Link2" },
  { name: "Redutores", icon: "Cog" },
  { name: "Automação", icon: "Cpu" },
  { name: "Pneumática", icon: "Wind" },
  { name: "Hidráulica", icon: "Droplets" },
  { name: "Ferramentas", icon: "Wrench" },
  { name: "Equipamentos Industriais", icon: "Factory" },
  { name: "Peças especiais", icon: "Sparkles" },
  { name: "Área Naval", icon: "Ship" },
  { name: "Área Petrolífera", icon: "Fuel" },
  { name: "Empilhadeiras & Peças", icon: "Forklift" },
  { name: "Pontes Rolantes & Peças", icon: "Crane" },
  { name: "Compressores de Ar & Peças", icon: "Gauge" },
  { name: "Máquinas de Jateamento & Peças", icon: "Wind" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Importação Especializada",
    desc: "Sourcing global, laudos técnicos e desembaraço completo para peças críticas e itens sob demanda.",
  },
  {
    step: "02",
    title: "Fornecimento Estratégico",
    desc: "Curadoria de fornecedores nacionais homologados para agilidade máxima em componentes de linha.",
  },
  {
    step: "03",
    title: "Agilidade Logística",
    desc: "Rotas priorizadas, rastreio ativo e SLA definido — a solução chega quando sua operação precisa.",
  },
  {
    step: "04",
    title: "Atendimento Consultivo",
    desc: "Engenheiros e consultores acompanham do diagnóstico técnico à entrega no seu almoxarifado.",
  },
];

export const INDICATORS = [
  { value: 12, suffix: "+", label: "Anos mantendo operações ativas" },
  { value: 3200, suffix: "+", label: "Itens sourceados em 2025" },
  { value: 97, suffix: "%", label: "Cotações respondidas em até 24h" },
  { value: 40, suffix: "+", label: "Países na rede de fornecedores" },
];

export const SOLUTIONS = [
  { title: "Importação Especializada", desc: "Sourcing global com curadoria técnica, laudos e desembaraço aduaneiro." , icon: "Plane" },
  { title: "Nacionalização de Componentes", desc: "Substituição de importados por equivalentes nacionais de alta qualidade.", icon: "Recycle" },
  { title: "Desenvolvimento de Soluções Técnicas", desc: "Engenharia aplicada a desafios operacionais complexos.", icon: "Wrench" },
  { title: "Fornecimento Estratégico", desc: "Planejamento de suprimentos alinhado à criticidade dos ativos.", icon: "PackageCheck" },
  { title: "Suporte Consultivo", desc: "Especialistas acompanham do briefing técnico à entrega.", icon: "Headphones" },
  { title: "Atendimento Emergencial", desc: "Ativação prioritária 24/7 para parar downtime crítico.", icon: "Siren" },
  { title: "Gestão de Itens Críticos", desc: "Curadoria, estoque estratégico e backup de componentes-chave.", icon: "ShieldCheck" },
  { title: "Soluções para Equipamentos Especiais", desc: "Peças descontinuadas, sob medida e para maquinário específico.", icon: "Sparkles" },
  { title: "Empilhadeiras & Peças", desc: "Empilhadeiras a combustão, elétricas e paleteiras — com peças de reposição e manutenção.", icon: "Forklift" },
  { title: "Pontes Rolantes & Peças", desc: "Componentes, cabos, motores e serviços para pontes rolantes industriais.", icon: "Crane" },
  { title: "Compressores de Ar Diesel & Elétricos & Peças", desc: "Compressores estacionários e portáteis + peças de reposição críticas.", icon: "Gauge" },
  { title: "Máquinas de Jateamento & Peças", desc: "Máquinas de shot blasting, granalhas e componentes de reposição.", icon: "Wind" },
];

export const NATIONALIZATION_FLOW = [
  { step: "Componente Importado", desc: "Peça atualmente importada, com custo, prazo e dependência externa altos." },
  { step: "Análise Técnica", desc: "Estudo de materiais, tolerâncias, normas e performance operacional." },
  { step: "Engenharia", desc: "Desenvolvimento da alternativa nacional com validação técnica." },
  { step: "Componente Nacional", desc: "Produção nacional homologada — mesma confiabilidade, menor custo." },
  { step: "Operação em Funcionamento", desc: "Instalação no ativo. Continuidade operacional garantida." },
];

export const FAQ = [
  {
    q: "O que são Soluções Corporativas e Industriais da Imporparts?",
    a: "Vamos muito além de fornecer peças. Somos parceiros estratégicos: fazemos engenharia de suprimentos, nacionalização de componentes, importação especializada, gestão de itens críticos e atendimento consultivo para manter sua operação em movimento.",
  },
  {
    q: "Como funciona a nacionalização de componentes?",
    a: "Analisamos tecnicamente o componente importado, desenvolvemos ou identificamos um equivalente nacional homologado e entregamos a solução com a mesma performance, reduzindo custo, prazo e dependência do mercado externo.",
  },
  {
    q: "Vocês trabalham com peças descontinuadas ou obsoletas?",
    a: "Sim. Localizamos e desenvolvemos alternativas para componentes fora de linha, com laudo técnico e rastreabilidade. Boa parte das nossas entregas envolve exatamente esse tipo de item crítico.",
  },
  {
    q: "Quanto tempo leva para receber uma cotação?",
    a: "97% das cotações são respondidas em até 24 horas úteis. Para urgências, o time técnico ativa fluxo prioritário via WhatsApp.",
  },
  {
    q: "Vocês emitem nota fiscal e atendem compras corporativas?",
    a: "Sim. Emitimos NF-e, atendemos processos de homologação de fornecedor e trabalhamos com pedidos de compra padronizados de indústrias, mineradoras, refinarias e estaleiros.",
  },
  {
    q: "Quais setores vocês atendem?",
    a: "Indústria, mineração, papel e celulose, portos, energia, petróleo e gás, offshore, refinarias, estaleiros, naval, agronegócio, logística, siderurgia, metalurgia, alimentos e química — sempre com foco em operação contínua.",
  },
];
